/* ================================
===    FACEBOOK RELOAD         ====
=================================== */
function reload_fb(element) {
  try {
    if ('undefined' !== typeof FB && 'undefined' !== typeof element && 'undefined' !== element && (theme_has_class($themeBody,'single') || theme_has_class($themeBody,'archive') || theme_has_class($themeBody,'search') || theme_has_class($themeBody,'page'))) {
      if(element){
        FB.XFBML.parse(element);
      }
    }
  } catch (err) {}
}

function reload_width_fb(element) {
  var container_width = element.parent().width();
  element.find('.fb_iframe_widget').data('width', container_width).attr('data-width', container_width);
  if(element.parent()[0]){
  reload_fb(element.parent()[0]);
  }
}
